/* eslint-disable */
export const API_WS_URL = process.env.REACT_APP_API_WS_URL;
export const API_HTTP_URL = process.env.REACT_APP_API_HTTP_URL;
export const NODE_API_URL = process.env.NODE_API_URL;
export const DEVELOPER_SECRET = process.env.REACT_APP_DEVELOPER_SECRET;
export const ENV = process.env.NODE_ENV;
export const INACTIVITY_TIMEOUT_IN_SECONDS = process.env.REACT_APP_INACTIVITY_TIMEOUT_IN_SECONDS;
export const INACTIVITY_WARNING_TIMEOUT_IN_SECONDS = process.env.REACT_APP_INACTIVITY_WARNING_TIMEOUT_IN_SECONDS;
